// extracted by mini-css-extract-plugin
var _1 = "App_footerWrapper__CHikc";
var _2 = "App_footerWrapperWelcome__XXLbC";
var _3 = "App_isPublic__AY9fe";
var _4 = "768px";
var _5 = "'../shared.module.css'";
export { _1 as "footerWrapper", _2 as "footerWrapperWelcome", _3 as "isPublic", _4 as "md", _5 as "shared" }
